const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

class RolesPermissionsService {
  constructor() {
    this.baseURL = `${API_BASE_URL}/api/roles_permissions`;
  }

  async getAuthHeaders() {
    const token = localStorage.getItem("token");
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  }

  // Get roles and permissions for matrix
  async getRolesPermissions() {
    try {
      const response = await fetch(this.baseURL, {
        method: "GET",
        headers: await this.getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching roles and permissions:", error);
      throw error;
    }
  }

  // Update role permissions
  async updateRolePermissions(rolePermissions) {
    try {
      const response = await fetch(this.baseURL, {
        method: "POST",
        headers: await this.getAuthHeaders(),
        body: JSON.stringify({ rolePermissions }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error updating role permissions:", error);
      throw error;
    }
  }
}

export default new RolesPermissionsService();
